import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import { Select, Col, Row, Input, Checkbox, Table, Modal, Tooltip } from "antd";
import backButton from '../../assets/images/back_button_arrow.svg';
import demandIcon from '../../assets/images/icons/demand_icon.svg';
import uploadIcon from '../../assets/images/icons/upload-cloud.svg';
import CreativeIcon from '../../assets/images/icons/add_creative_icon.svg';
import creativetemicon from '../../assets/images/icons/creative_tem_icon.svg';
import macrosicon from '../../assets/images/icons/macros_modal_icon.svg';
import { SearchOutlined } from '@ant-design/icons';
import tablecopyIcon from '../../assets/images/icons/table_copy_icon.svg';
import eyeIcon from '../../assets/images/icons/eye_icon.svg';
import addIcon from '../../assets/images/icons/add.svg';
import editIcon from '../../assets/images/icons/edit.svg';
import DeleteIcon from '../../assets/images/icons/delete_icon.svg';

const { Option } = Select;

function resetFormView() { };

const { TextArea } = Input;




const data = [
    {
        id: '1',
        sitename: 'CTV-RTB-Aniview',
        sitetype: 'FreeWheel',
        zones: '4',
        inventorytype: 'TV: Over-the-top',
    },
    // Add more data objects here
];



const ForthForm = ({ handlePageViewChange }) => {
    const columns = [
        {
            title: '',
            dataIndex: 'action',
            width: 100,
            render: (text, record) => (
                <div className='btn_group'>
                    <Tooltip title="Edit">
                        <button className='download_icon download_icon_d2'>
                            <img src={editIcon} alt='USP' />
                        </button>
                    </Tooltip>
                    <Tooltip title="View">
                        <button className='download_icon download_icon_d2' onClick={showModalView}>
                            <img src={eyeIcon} alt='USP' />
                        </button>
                    </Tooltip>
                    <Tooltip title="Clone">
                        <button className='download_icon download_icon_d2'>
                            <img src={tablecopyIcon} alt='USP' />
                        </button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <button className='download_icon download_icon_d2'>
                            <img src={DeleteIcon} alt='Delete' />
                        </button>
                    </Tooltip>
                </div >
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: 100,
            render: (text, record) => <div className='w_100 position-relative'>
                <Select
                    className="form_select badge_content--approved"
                    dropdownStyle={{
                        width: '12rem'
                    }}
                    value="Enabled"
                    options={
                        [{ label: "Enabled", value: "Enabled" }, { label: "Disabled", value: "Disabled" }]
                    }
                />
            </div>
        },
        {
            title: 'Name',
            dataIndex: 'name',
            sorter: true,
            render: () => <div className='text_dark_800'>Xapads-Internal-O&O</div>,
        },
        {
            title: 'Type',
            dataIndex: 'type',
            sorter: true,
            render: () => <div className="text_dark_800">HTML</div>,
        },
        {
            title: 'Size',
            dataIndex: 'size',
            sorter: true,
            render: () => <div className="text_dark_800">300 x 250</div>,
        },
    ];

    // Modal Start
    const [isModalVisibleView, setIsModalVisibleView] = useState(false);
    const showModalView = () => {
        setIsModalVisibleView(true);
    };

    const closeTemplateModalView = () => {
        setIsModalVisibleView(false);
    };

    const [isModalVisibleMacros, setIsModalVisibleMacros] = useState(false);
    const showModalMacros = () => {
        setIsModalVisibleMacros(true);
    };

    const closeTemplateModalMacros = () => {
        setIsModalVisibleMacros(false);
    };

    const [isModalVisible, setIsModalVisible] = useState(false);
    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };
    //Modal End

    const [searchValue, setSearchValue] = useState('');
    const [filterApply, setFilterApply] = useState({
        publisher: [],
    });
    const [isTemplateModalOpen, setTemplateModalOpen] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Control dropdown open state

    const temoptions = [
        { value: 'template1', label: 'Template 1' },
        { value: 'template2', label: 'Template 2' },
        { value: 'template3', label: 'Template 3' },
        { value: 'template4', label: 'Template 4' },
    ];

    const openTemplateModal = () => {
        setTemplateModalOpen(true);
        setIsDropdownOpen(false); // Close the Select dropdown
    };

    const closeTemplateModal = () => {
        setTemplateModalOpen(false);
    };
    const options = [
        { value: 'jack1', label: 'Jack 1' },
        { value: 'lucy1', label: 'Lucy 1' },
        { value: 'lucy8', label: 'Lucy 8' },
        { value: 'tom8', label: 'Tom 8' },
        { value: 'jack9', label: 'Jack 9' },
        { value: 'lucy9', label: 'Lucy 9' },
        { value: 'tom9', label: 'Tom 9' },
    ];


    const handleSearch = (e) => {
        setSearchValue(e.target.value.toLowerCase());
    };

    const onChange = (value) => {
        console.log(`Selected: ${value}`);
    };

    const handleFilterApply = (type, value) => {
        setFilterApply((prev) => {
            const currentPublishers = prev.publisher;
            const isSelected = currentPublishers.includes(value);

            // Toggle selection
            const updatedPublishers = isSelected
                ? currentPublishers.filter((item) => item !== value)
                : [...currentPublishers, value];

            return { ...prev, publisher: updatedPublishers };
        });
    };

    // Filtering options based on search input
    const filteredOptions = options.filter((option) =>
        option.label.toLowerCase().includes(searchValue)
    );

    const [search, setSearch] = useState("");
    const [filteredData, setFilteredData] = useState(data);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const startItem = (current - 1) * pageSize + 1;
    const endItem = Math.min(current * pageSize, filteredData.length);

    // Update filtered data based on search input
    useEffect(() => {
        if (search.trim()) {
            const filtered = data.filter((item) =>
                item.sitename.toLowerCase().includes(search.toLowerCase()) ||
                item.inventorytype.toLowerCase().includes(search.toLowerCase())
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(data);
        }
    }, [search]);

    const handleChange = (page) => {
        setCurrent(page);
    };

    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}>
                                <img src={demandIcon} alt="USP" /> GAM
                            </Link>
                        </li>
                        <li>Campaign</li>
                        <li className="primary">New Campaign</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between align-items-center">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }} />
                        <h1 className="heading"> Create Campaign </h1>
                    </div>
                    <div className='li_tabs_designs'>
                        <ul>
                            <li className='active_li_tab completed_li_tab'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 5.625V6.875" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 13.125V14.375" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.125 13.125H10.9375C11.3519 13.125 11.7493 12.9604 12.0424 12.6674C12.3354 12.3743 12.5 11.9769 12.5 11.5625C12.5 11.1481 12.3354 10.7507 12.0424 10.4576C11.7493 10.1646 11.3519 10 10.9375 10H9.0625C8.6481 10 8.25067 9.83538 7.95765 9.54235C7.66462 9.24933 7.5 8.8519 7.5 8.4375C7.5 8.0231 7.66462 7.62567 7.95765 7.33265C8.25067 7.03962 8.6481 6.875 9.0625 6.875H11.875" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Budget
                            </li>
                            <li className=''>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M1.875 14.375V12.5859C1.875 8.09375 5.48437 4.39062 9.96875 4.375C11.0384 4.37089 12.0983 4.57801 13.0877 4.98449C14.077 5.39096 14.9764 5.98879 15.7342 6.74368C16.492 7.49857 17.0933 8.39565 17.5035 9.38346C17.9138 10.3713 18.125 11.4304 18.125 12.5V14.375C18.125 14.5408 18.0592 14.6997 17.9419 14.8169C17.8247 14.9342 17.6658 15 17.5 15H2.5C2.33424 15 2.17527 14.9342 2.05806 14.8169C1.94085 14.6997 1.875 14.5408 1.875 14.375Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 4.375V6.875" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M2.14844 10.3984L4.57031 11.0469" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M17.8516 10.3984L15.4297 11.0469" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.07812 15L13.4219 8.03906" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Optimization
                            </li>
                            <li className=''>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85787 14.1421 2.5 10 2.5C5.85787 2.5 2.5 5.85787 2.5 10C2.5 14.1421 5.85787 17.5 10 17.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.002 14.5C12.4872 14.5 14.502 12.4853 14.502 10C14.502 7.51472 12.4872 5.5 10.002 5.5C7.51667 5.5 5.50195 7.51472 5.50195 10C5.50195 12.4853 7.51667 14.5 10.002 14.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Targeting
                            </li>
                            {/* <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M2 3.73383V8.43381H6.69998" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3.96616 12.3505C4.47406 13.7921 5.43673 15.0296 6.70911 15.8765C7.98149 16.7235 9.49465 17.1339 11.0206 17.0461C12.5466 16.9583 14.0026 16.3769 15.1694 15.3896C16.3362 14.4023 17.1506 13.0625 17.4897 11.5721C17.8289 10.0817 17.6745 8.52151 17.0498 7.12651C16.4251 5.73151 15.364 4.57732 14.0263 3.83783C12.6886 3.09834 11.1469 2.81363 9.6333 3.02658C8.11973 3.23953 6.71636 3.93861 5.63465 5.01849L2 8.43381" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Retargeting
                            </li> */}
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M15.4444 3H4.55556C3.69645 3 3 3.69645 3 4.55556V15.4444C3 16.3036 3.69645 17 4.55556 17H15.4444C16.3036 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.3036 3 15.4444 3Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.27799 8.44444C7.92233 8.44444 8.44466 7.92211 8.44466 7.27778C8.44466 6.63345 7.92233 6.11111 7.27799 6.11111C6.63366 6.11111 6.11133 6.63345 6.11133 7.27778C6.11133 7.92211 6.63366 8.44444 7.27799 8.44444Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16.9991 12.3333L13.1102 8.44444L4.55469 17" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Ads
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="container_box--content pt_20 form_scrollable_div_d2">
                    <div className="container_box--width">
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Ad Creatives</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container border-0 p-0">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group mb-0">
                                                <label for='fileUploader' className='ant_upload_drag' onClick={showModal}>
                                                    <p className="upload_drag_icon"> <img src={uploadIcon} alt='USP' /> </p>
                                                    <p className="ant_upload_text"><b className="primary">Add Creative </b></p>
                                                </label>
                                                {/* <input className='form_upload d-none' type="file" id="fileUploader" name="fileUploader" /> */}
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div>
                                    <div className="d_flex align-items-center justify_content_between w-100 mb_10">
                                        <div className='form_content_block--group'>
                                            <Input
                                                className='form_control basic md search_input w_table_search'
                                                placeholder="Search"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                            />
                                        </div>
                                        <button className='btn btn_primary w_fit_content md'>
                                            <span><img src={addIcon} alt='USP' /> Upload </span>
                                        </button>
                                    </div>
                                    <div className="table_content--box form_table_design_d2">
                                        <Table
                                            columns={columns}
                                            dataSource={filteredData.slice((current - 1) * pageSize, current * pageSize)}
                                            pagination={false}
                                            scroll={{ x: 'max-content', y: 'calc(100vh - 32rem' }}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div >
                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        <button className="w_120_d2 btn btn_white_outline w_fit_content"> Back </button>
                        <button className="w_120_d2 btn btn_primary w_fit_content">Create</button>
                    </div>
                </div >
            </div >

            <Modal
                className='custom_modal custom_modal_form_d2' onCancel={handleCancel}
                title={<div className='custom_modal--header'><h3 className='heading'><img src={CreativeIcon} alt='USP' /> Add Creative</h3>
                </div>}
                closable={true} // This removes the default close button
                visible={isModalVisible}
                maskClosable={false}
                width={780}
                footer={[
                    <div className="custom_modal--footer d_flex justify_content_end gap_8">
                        <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={handleOk}> Discard </button>
                        <button key="submit" className='btn btn_primary w_fit_content' >
                            Submit
                        </button>
                    </div>
                ]}>
                <div className="custom_modal--body">
                    <div className="tab_content--body">
                        <div className="container_box--width w-100">
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <label className="form_label">Creative Type </label>
                                <Select
                                    showSearch
                                    className='form_select basic no_search'
                                    placeholder=""
                                    optionFilterProp="label"
                                    options={options}
                                />
                                <span className="error_content"> </span>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <label className="form_label">Name </label>
                                <Input className='form_control basic ' placeholder='' autocomplete="off" />
                                <span className="error_content"> </span>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <div className='d-flex align-items-center justify-content-between'>
                                    <label className="form_label">Destination URL </label>
                                    <span className='Supported_macros_text' onClick={showModalMacros}>Supported macros</span>
                                </div>
                                <Input className='form_control basic ' placeholder='https://' autocomplete="off" />
                                <span className="error_content"> </span>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <label className="form_label">Ad domains </label>
                                <Input className='form_control basic ' placeholder='Enter ad domains, separated by comma' autocomplete="off" />
                                <span className="error_content"> </span>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <label className="form_label">App Bundle </label>
                                <Input className='form_control basic ' placeholder='' autocomplete="off" />
                                <span className="error_content"> </span>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <label className="form_label">Position </label>
                                <Select
                                    showSearch
                                    className='form_select basic no_search'
                                    placeholder="-Select-"
                                    optionFilterProp="label"
                                    options={options}
                                />
                                <span className="error_content"> </span>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <div className="primary_checkbox">
                                    <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                        <span className="form_label">
                                            Interstitial
                                        </span>
                                    </Checkbox>
                                </div>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                    <label className="form_label">Attributes </label>
                                    <Select
                                        id="adcodeSelect"
                                        value={filterApply.publisher}
                                        popupClassName='diff_select_d2 --full'
                                        // open={true}
                                        showSearch={false}
                                        placeholder='- Select -'
                                        className="form_select basic"
                                        mode='multiple'
                                        maxTagCount='responsive'
                                        dropdownRender={menu => (
                                            <>
                                                <div className="custom_inside_searchbar_d2">
                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                </div>
                                                {menu}
                                            </>
                                        )}
                                    >
                                        {filteredOptions.map(option => (
                                            <Option key={option.value} value={option.value}>
                                                <div
                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                >
                                                    <Checkbox
                                                        checked={filterApply.publisher.includes(option.value)}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        {option.label}
                                                    </Checkbox>
                                                </div>
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <label className="form_label">Impression pixels </label>
                                <Input className='form_control basic ' placeholder='Impression pixels' autocomplete="off" />
                                <span className="error_content"> </span>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <label className="form_label">JS trackersz </label>
                                <Input className='form_control basic ' placeholder='' autocomplete="off" />
                                <span className="error_content"> </span>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <label className="form_label">Size </label>
                                <Select
                                    showSearch
                                    className='form_select basic no_search'
                                    placeholder="-Select-"
                                    optionFilterProp="label"
                                    options={options}
                                />
                                <span className="error_content"> </span>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <div className="primary_checkbox">
                                    <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                        <span className="form_label">
                                            3rd party
                                        </span>
                                    </Checkbox>
                                </div>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <div className="primary_checkbox">
                                    <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                        <span className="form_label">
                                            Secure
                                        </span>
                                    </Checkbox>
                                </div>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <label className="form_label">Template </label>
                                <Select
                                    open={isDropdownOpen} // Controlled open state for Select dropdown
                                    onDropdownVisibleChange={(open) => setIsDropdownOpen(open)} // Track dropdown visibility
                                    showSearch
                                    className="form_select basic no_search"
                                    placeholder="-Select-"
                                    value={selectedTemplate}
                                    optionFilterProp="label"
                                    onChange={setSelectedTemplate}
                                    dropdownRender={(menu) => (
                                        <>
                                            {/* Custom "New Template" clickable item */}
                                            <div
                                                style={{
                                                    padding: '8px',
                                                    cursor: 'pointer',
                                                    color: '#9254de',
                                                    borderBottom: '1px solid #f0f0f0',
                                                }}
                                                onClick={openTemplateModal}
                                            >
                                                + New Template
                                            </div>
                                            {/* Render the default menu with normal options */}
                                            {menu}
                                        </>
                                    )}
                                    options={temoptions}
                                />
                                <span className="error_content"> </span>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <label className="form_label">Banner </label>
                                <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h --160 textarea_paddingY_d2' />
                                <span className="error_content"> </span>
                            </div>
                            <div className="form_content_block--group modal_form_bottom_gap_d2 hide_caret_after_select_value">
                                <Row gutter={8}>
                                    <Col span={7}>
                                        <label className="form_label">App Bundles List </label>
                                        <Select
                                            showSearch
                                            className='form_select basic no_search'
                                            placeholder="-Select-"
                                            optionFilterProp="label"
                                            onChange={onChange}
                                            // onSearch={onSearch}
                                            options={[
                                                {
                                                    value: 'jack',
                                                    label: 'Jack',
                                                },
                                                {
                                                    value: 'lucy',
                                                    label: 'Lucy',
                                                },
                                                {
                                                    value: 'tom',
                                                    label: 'Tom',
                                                },
                                            ]}
                                        />
                                        <span className="error_content"> </span>
                                    </Col>
                                    <Col span={17}>
                                        <div className="form_content_block--group mb-0">
                                            <label className="form_label invisible">App Bundles List </label>
                                            <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h --80 textarea_paddingY_d2' />
                                            <span className="error_content"></span>
                                        </div>
                                        <span className="error_content"> </span>
                                    </Col>
                                </Row>
                            </div>
                            <div className="form_content_block--group hide_caret_after_select_value">
                                <Row gutter={8}>
                                    <Col span={7}>
                                        <label className="form_label">Domain List </label>
                                        <Select
                                            showSearch
                                            className='form_select basic no_search'
                                            placeholder="-Select-"
                                            optionFilterProp="label"
                                            onChange={onChange}
                                            // onSearch={onSearch}
                                            options={[
                                                {
                                                    value: 'jack',
                                                    label: 'Jack',
                                                },
                                                {
                                                    value: 'lucy',
                                                    label: 'Lucy',
                                                },
                                                {
                                                    value: 'tom',
                                                    label: 'Tom',
                                                },
                                            ]}
                                        />
                                        <span className="error_content"> </span>
                                    </Col>
                                    <Col span={17}>
                                        <div className="form_content_block--group mb-0">
                                            <label className="form_label invisible">Domain List </label>
                                            <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h textarea_paddingY_d2' disabled />
                                            <span className="error_content"></span>
                                        </div>
                                        <span className="error_content"> </span>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                className='custom_modal custom_modal_form_d2'
                visible={isTemplateModalOpen}
                onOk={closeTemplateModal}
                width={780}
                onCancel={closeTemplateModal}
                maskClosable={false}
                title={<div className='custom_modal--header'><h3 className='heading'><img src={creativetemicon} alt='USP' /> Create Template</h3>
                </div>}
                closable={true} // This removes the default close button
                footer={[
                    <div className="custom_modal--footer d_flex justify_content_end">
                        <div className="btn_group justify-content-end gap_8">
                            <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={closeTemplateModal}> Discard </button>
                            <button className="w_120_d2 btn btn_primary w_fit_content">Create</button>
                        </div>
                    </div>
                ]}>
                <div className="custom_modal--body">
                    <div className="form_content_block--group modal_form_bottom_gap_d2">
                        <label className="form_label">Template Name * </label>
                        <Input className='form_control basic ' placeholder='' autocomplete="off" />
                        <span className="error_content"> </span>
                    </div>
                    <div className="form_content_block--group">
                        <label className="form_label">Tag * </label>
                        <TextArea autocomplete="off" placeholder='' className='form_control basic form_control_h --160 textarea_paddingY_d2' />
                        <span className="error_content"> </span>
                    </div>

                </div>
            </Modal>
            <Modal
                className='custom_modal custom_modal_form_d2'
                visible={isModalVisibleMacros}
                onOk={closeTemplateModalMacros}
                width={780}
                onCancel={closeTemplateModalMacros}
                maskClosable={false}
                title={
                    <div className='custom_modal--header'><h3 className='heading'><img src={macrosicon} alt='USP' /> Supported macros</h3>
                    </div>
                }
                closable={true} // This removes the default close button
                footer={[
                    <div className="custom_modal--footer d_flex justify_content_end d-none">
                        <div className="btn_group justify-content-end gap_8">
                            <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={closeTemplateModalMacros}> Discard </button>
                            <button className="w_120_d2 btn btn_primary w_fit_content">Create</button>
                        </div>
                    </div>
                ]}
            >
                <div className="custom_modal--body">
                    <div className='all_macros_tag_d2'>
                        <Row gutter={8}>
                            <Col span={12}>
                                <ul>
                                    <li>&#123;creative_id&#125; – <span>creative id</span></li>
                                    <li>&#123;publisher_id&#125; – <span>publisher id</span></li>
                                    <li>&#123;exchange&#125; – <span>exchange</span></li>
                                    <li>&#123;domain&#125; – <span>domain (referrer)</span></li>
                                    <li>&#123;app_name&#125; – <span>application name</span></li>
                                    <li>&#123;site_id&#125; – <span>site id</span></li>
                                    <li>&#123;country&#125; – <span>country</span></li>
                                    <li>&#123;city&#125; – <span>city</span></li>
                                    <li>&#123;os&#125; – <span>os</span></li>
                                    <li>&#123;make&#125; – <span>make</span></li>
                                    <li>&#123;carrier&#125; – <span>carrier</span></li>
                                    <li>&#123;device_type&#125; – <span>device type</span></li>
                                    <li>&#123;ipv4_address&#125; – <span>ipv4 address</span></li>
                                    <li>&#123;cachebuster&#125; – <span>random number</span></li>
                                    <li>&#123;tagid&#125; – <span>imp.tagid parameter of bid request</span></li>
                                    <li>$&#123;GDPR_CONSENT_XXX&#125; – <span>base64-encoded GDPR consent string</span></li>
                                    <li>$&#123;ADDTL_CONSENT&#125; – <span>Google"s additional consent</span></li>
                                </ul>
                            </Col>

                            <Col span={12}>
                                <ul>
                                    <li>&#123;creative_id&#125; – <span>creative id</span></li>
                                    <li>&#123;publisher_id&#125; – <span>publisher id</span></li>
                                    <li>&#123;exchange&#125; – <span>exchange</span></li>
                                    <li>&#123;domain&#125; – <span>domain (referrer)</span></li>
                                    <li>&#123;app_name&#125; – <span>application name</span></li>
                                    <li>&#123;site_id&#125; – <span>site id</span></li>
                                    <li>&#123;country&#125; – <span>country</span></li>
                                    <li>&#123;city&#125; – <span>city</span></li>
                                    <li>&#123;os&#125; – <span>os</span></li>
                                    <li>&#123;make&#125; – <span>make</span></li>
                                    <li>&#123;carrier&#125; – <span>carrier</span></li>
                                    <li>&#123;device_type&#125; – <span>device type</span></li>
                                    <li>&#123;ipv4_address&#125; – <span>ipv4 address</span></li>
                                    <li>&#123;cachebuster&#125; – <span>random number</span></li>
                                    <li>&#123;tagid&#125; – <span>imp.tagid parameter of bid request</span></li>
                                    <li>$&#123;GDPR_CONSENT_XXX&#125; – <span>base64-encoded GDPR consent string</span></li>
                                    <li>$&#123;ADDTL_CONSENT&#125; – <span>Google"s additional consent</span></li>
                                </ul>
                            </Col>

                        </Row>
                    </div>
                </div>
            </Modal>

            <Modal
                className='custom_modal custom_modal_form_d2'
                wrapClassName="full_screen_modal_d2"
                visible={isModalVisibleView}
                onOk={closeTemplateModalView}
                onCancel={closeTemplateModalView}
                maskClosable={false}
                // title={
                //     <div className='custom_modal--header'><h3 className='heading'><img src={macrosicon} alt='USP' /> Supported macros</h3>
                //     </div>
                // }
                closable={true} // This removes the default close button
                footer={[
                    <div className="custom_modal--footer d_flex justify_content_end d-none">
                        <div className="btn_group justify-content-end gap_8">
                            <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={closeTemplateModalView}> Discard </button>
                            <button className="w_120_d2 btn btn_primary w_fit_content">Create</button>
                        </div>
                    </div>
                ]}>
                <div className="custom_modal--body">
                    <div className='modal_body_img'>
                        <img src='https://images.unsplash.com/photo-1721332149346-00e39ce5c24f?q=80&w=1936&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' alt="" />
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default ForthForm

